// Ensures product gallery videos autoplay without controls
(function() {
  const playVideos = () => {
    document.querySelectorAll('.product-gallery video.media-video').forEach((video) => {
      video.controls = false;
      video.muted = true;
      const attemptPlay = () => {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      };
      attemptPlay();
      // If autoplay was blocked, play after user interaction
      video.addEventListener('click', attemptPlay, { once: true });
      document.addEventListener('click', attemptPlay, { once: true });
    });
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    playVideos();
  } else {
    document.addEventListener('DOMContentLoaded', playVideos);
  }
})();
